import { apiClient } from './api';
import { MultiTechDocRequest, MultiTechDocResponse } from '../models/techDoc';

export class TechDocService {
  static async generateTechDoc(request: MultiTechDocRequest): Promise<MultiTechDocResponse> {
    const response = await apiClient.post('/api/multi-agent/techdoc/start', request);
    return response.data;
  }
}

export default TechDocService;